module.exports = __webpack_public_path__ + "img/title-summary@3x.50a5f66d.png";